import { Formik, getIn } from "formik";
import { FC, useEffect, useState } from "react";


import { useTranslation } from "react-i18next";
import { CreateKYCPackFormValues, createKYCPackFormValidationSchema, createKYCPackFormValuesInitialValue } from ".";
import { Box, Card, CardContent, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, TextField, Typography } from "@material-ui/core";
import { H2 } from "../../../components/typography";
import { PrimaryButton } from "../../../components/button";
import { successNotificationFromPromise } from "../../../store/notifications/utils";
import { KycFile, KycTypedFile, useDocumentsEmailMutation, useDocumentsHistoryQuery } from "../../../store/models/risk";
import { processErrorFromPromise } from "../../../store/errors/utils";

interface CreateKYCPackFormProps {
}
export const KYCPackForm: FC<CreateKYCPackFormProps> = () => {

    const { data: history } = useDocumentsHistoryQuery(
        { latest: true },
        { refetchOnMountOrArgChange: true }
    );

    const [dataHistory, setDataHistory] = useState<KycTypedFile[]>([]);

    useEffect(() => {

        if (history) {
            let result: KycTypedFile[] = [];
            for (const [key, value] of Object.entries(history.documents) as any) {
                let subResult = value.map((v: KycFile) => ({ type: key, ...v }))
                result = [...result, ...subResult]
            }
            setDataHistory(result);
        }

    }, [history]);

    const [sendDocuments] = useDocumentsEmailMutation();
    const { t } = useTranslation();
    const [disableButton, setDisableButton] = useState<boolean>(false);
    return (
        <Formik<CreateKYCPackFormValues>
            enableReinitialize
            initialValues={{
                ...createKYCPackFormValuesInitialValue(),
            }}
            validationSchema={createKYCPackFormValidationSchema(
            )}
            onSubmit={async (values): Promise<void> => {
                try {
                    setDisableButton(true);
                    let documentIds: string[] = [];
                    if (values.selfie === true && dataHistory.some(x => x.type === 'FACE')) {
                        documentIds = [...documentIds, ...dataHistory.filter(h => h.type === 'FACE').map(m => m.id)]
                    }
                    if (values.proofOfAddress === true &&
                        dataHistory.some(x => ["EMPLOYER_LETTER",
                            "TAX_BILL",
                            "UTILITY_BILL",
                            "RENT_AGREEMENT",
                            "BANK_STATEMENT"].includes(x.type))) {
                        documentIds = [...documentIds, ...dataHistory.filter(h => ["EMPLOYER_LETTER",
                            "TAX_BILL",
                            "UTILITY_BILL",
                            "RENT_AGREEMENT",
                            "BANK_STATEMENT"].includes(h.type)).map(m => m.id)]
                    }
                    if (values.identityDocument === true && dataHistory.some(x => ["DRIVING_LICENSE", "ID_CARD", "PASSPORT"].includes(x.type))) {
                        documentIds = [...documentIds, ...dataHistory.filter(h => ["DRIVING_LICENSE", "ID_CARD", "PASSPORT"].includes(h.type)).map(m => m.id)]
                    }



                    sendDocuments({ recipientEmailAddress: values.recipientEmailAddress!, recipientName: values.recipientName, documentIds: documentIds })
                        .unwrap()
                        .then(
                            successNotificationFromPromise('Documents sent successfully')
                        )
                        .catch(processErrorFromPromise
                        ).finally(() => {
                            setDisableButton(false);
                        })

                } catch (err) {
                    console.log(err);
                }
            }}
        >
            {({
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                values,
                setFieldValue,
                errors,
                touched,
            }): JSX.Element => (
                <>
                    {/* <pre>{JSON.stringify(history, null, 2)}</pre> */}
                    {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
                    {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                    {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    <Card >
                        <CardContent>
                            <Box sx={{ padding: "32px" }}>
                                <form noValidate onSubmit={handleSubmit}>




                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <small>
                                                <H2> Who do you want to send your KYC Pack to?</H2>
                                            </small>
                                        </Grid>

                                        <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                            <Typography variant="body2">Recepient's Name</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={8}>
                                            <FormControl fullWidth margin='dense'
                                            >
                                                <TextField name={'recipientName'} variant="outlined" value={getIn(values, 'recipientName')} onBlur={handleBlur} onChange={handleChange}
                                                    error={Boolean(getIn(touched, 'recipientName') && !!getIn(errors, 'recipientName'))}
                                                    helperText={getIn(touched, 'recipientName') && getIn(errors, 'recipientName')} />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                            <Typography variant="body2">Recepient's Email</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={8}>
                                            <FormControl fullWidth margin='dense'>
                                                <TextField name={'recipientEmailAddress'} variant="outlined" value={getIn(values, 'recipientEmailAddress')} onBlur={handleBlur} onChange={handleChange}
                                                    error={Boolean(getIn(touched, 'recipientEmailAddress') && !!getIn(errors, 'recipientEmailAddress'))}
                                                    helperText={getIn(touched, 'recipientEmailAddress') && getIn(errors, 'recipientEmailAddress')} />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12} sm={6} lg={4} style={{ alignItems: 'center', display: 'flex' }}>
                                            <Typography variant="body2"> Select Files to include in the KYC Pack:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={8}>
                                            <FormControl fullWidth margin='dense'>
                                                <FormControl component="fieldset" >
                                                    {/* <FormLabel component="legend">Assign responsibility</FormLabel> */}
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={getIn(values, 'selfie')} onChange={handleChange} name="selfie" />}
                                                            label="Selfie"
                                                        />
                                                        <FormControlLabel
                                                            control={<Checkbox checked={getIn(values, 'proofOfAddress')} onChange={handleChange} name="proofOfAddress" />}
                                                            label="Proof of address"
                                                        />

                                                        <FormControlLabel
                                                            control={<Checkbox checked={getIn(values, 'identityDocument')} onChange={handleChange} name="identityDocument" />}
                                                            label="Identity Document"
                                                        />
                                                        <FormHelperText error>{getIn(errors, 'documents')}</FormHelperText>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={getIn(values, 'includeCertificate')} onChange={handleChange} name="includeCertificate" />}
                                                            label="Sekuritance Identity Certificate"
                                                        />
                                                        {/* <FormControlLabel
                                                            control={<Checkbox checked={false} onChange={handleChange} name="documentIds[5]" />}
                                                            label="List of verified wallets"
                                                        /> */}
                                                    </FormGroup>
                                                </FormControl>




                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <PrimaryButton
                                            disabled={disableButton}
                                            type="submit">Send</PrimaryButton>
                                    </Box>

                                </form>
                            </Box>
                        </CardContent>
                    </Card>
                </>
            )}
        </Formik>
    );
};